var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    fill: "none",
    viewBox: "0 0 12 12",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#A9ACBD",
    d: "M6 0C2.692 0 0 2.692 0 6s2.692 6 6 6 6-2.692 6-6-2.692-6-6-6zm.39 9.56c-.285.047-.852.166-1.14.19-.244.02-.474-.12-.614-.32s-.174-.456-.091-.686l1.134-3.119H4.5c-.001-.65.486-1.128 1.11-1.311.297-.088.852-.207 1.14-.189.173.011.474.12.614.32s.174.456.09.686L6.322 8.25H7.5c0 .65-.47 1.203-1.11 1.31zm.36-5.81C6.336 3.75 6 3.414 6 3s.336-.75.75-.75.75.336.75.75-.336.75-.75.75z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/vector.28657fc3dc69ddea7f59e0c143aea672.svg";
export { ForwardRef as ReactComponent };